import axios from 'axios';
import { useAuthStore } from './store/authStore';
import { useDialogStore } from './store/dialogStore';
import { useNavigate } from 'react-router-dom';

const axiosInstance = axios.create({
  // @ts-expect-error TS1343: The 'import.meta' meta-property is only allowed when the '--module' option is 'es2020', 'es2022', 'esnext', 'system', 'node16',
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const pendingRequests = new Map<string, number>();

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const currentTime = Date.now();
    const lastRequestTime = pendingRequests.get(config.url || '');

    if (lastRequestTime && currentTime - lastRequestTime < 1000) {
      return Promise.reject('Duplicate request detected');
    }

    pendingRequests.set(config.url || '', currentTime);

    // await new Promise((resolve) => setTimeout(resolve, 500));

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    pendingRequests.delete(response.config.url || '');
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401 && window.location.pathname !== '/') {
        const logout = useAuthStore.getState().logout;
        logout();
        const navigate = useNavigate();
        navigate('/');
        return Promise.reject('Unauthorized access - redirected to login.');
      } else if ([400, 500, 401].includes(status)) {
        const openDialog = useDialogStore.getState().openDialog;
        openDialog(`Error : ${data?.message || ''}`, () => {
          useDialogStore.getState().closeDialog();
        });
        return Promise.reject(`Error ${status}: ${data?.message || ''}`);
      }
    }
    return Promise.reject('An error occurred while processing your request.');
  },
);

export default axiosInstance;
